import { chain } from 'lodash';

// implementation of imgix-url filter for non-angular environment
function getImgixUrl(imgixFileAndParams: string): string {
  const [imgixFilename, imgixParamsString] = imgixFileAndParams.split('?');

  let imgixParams = {};
  if (imgixParamsString) {
    imgixParams = chain(imgixParamsString)
      .split('&')
      .map((param) => param.split('='))
      .fromPairs()
      .value();
  }

  const defaultImgixParams = {
    auto: 'format,compress', // reduce size, increase page speed, use most efficient image format
    ch: 'Width,DPR', // client hinting, where available
    dpr: '2', // 2x display for retina screens by default,
    fit: 'max', // use the `w` and `h` params as maximums
  };

  const params = chain(imgixParams)
    .defaults(defaultImgixParams)
    .map((value: string, key: string) => `${key}=${value}`)
    .sort()
    .join('&')
    .value();

  return `https://imgdrop.imgix.net/${imgixFilename}?${params}`;
}

export default getImgixUrl;
